import { provideKeycloak, withAutoRefreshToken, AutoRefreshTokenService, UserActivityService } from "keycloak-angular";
import { environment } from "src/environments/environment";

export const provideKeycloakAngular = () =>
    provideKeycloak({
        config: {
            url: environment.keycloakUrl,
            realm: environment.keycloakRealm,
            clientId: environment.keycloakClientId,
        },
        initOptions: {
            onLoad: 'login-required',
            checkLoginIframe: environment.production,
            checkLoginIframeInterval: 60
        },
        features: [
            withAutoRefreshToken({
                onInactivityTimeout: 'logout',
                sessionTimeout: 60000
            })
        ],
        providers: [AutoRefreshTokenService, UserActivityService]
    });